module.exports = __webpack_public_path__ + "static/media/gear.cdaf995e.svg";